import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=cff30208&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=js&"
export * from "./UserPage.vue?vue&type=script&lang=js&"
import style0 from "./UserPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserPage.vue?vue&type=style&index=1&id=cff30208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff30208",
  null
  
)

export default component.exports